import { render } from "./SavedFilters.vue?vue&type=template&id=5254715f"
import script from "./SavedFilters.vue?vue&type=script&lang=js"
export * from "./SavedFilters.vue?vue&type=script&lang=js"

import "./SavedFilters.vue?vue&type=style&index=0&id=5254715f&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__